import { useState } from 'react';
import { cn } from '@/utils/cn';

interface PreviewAvatarProps {
  colorClass: string;
  size?: 'sm' | 'md' | 'lg';
  initials?: string;
  ring?: boolean; // Instagram-style ring
  avatarUrl?: string;
}

export const PreviewAvatar = ({
  colorClass,
  size = 'md',
  initials = '?',
  ring = false,
  avatarUrl,
}: PreviewAvatarProps) => {
  const [imageError, setImageError] = useState(false);

  const sizeClasses = {
    sm: 'w-6 h-6 text-[8px]',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-sm',
  };

  // Render avatar content (either image or initials)
  const avatarContent = avatarUrl && !imageError ? (
    <img
      src={avatarUrl}
      alt="Profile"
      className="w-full h-full object-cover rounded-full"
      onError={() => setImageError(true)}
    />
  ) : (
    <div
      className={cn(
        'w-full h-full rounded-full flex items-center justify-center text-white font-bold',
        colorClass
      )}
    >
      {initials}
    </div>
  );

  const avatar = (
    <div
      className={cn(
        'rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden',
        sizeClasses[size]
      )}
    >
      {avatarContent}
    </div>
  );

  if (ring) {
    return (
      <div className={cn('rounded-full p-0.5 bg-gradient-to-tr from-purple-500 via-pink-500 to-orange-400')}>
        <div
          className={cn(
            'rounded-full bg-white flex items-center justify-center overflow-hidden',
            sizeClasses[size]
          )}
        >
          {avatarUrl && !imageError ? (
            <img
              src={avatarUrl}
              alt="Profile"
              className="w-full h-full object-cover"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[10px] font-bold text-gray-800 bg-gray-200">
              {initials}
            </div>
          )}
        </div>
      </div>
    );
  }

  return avatar;
};
